<app-data-grid-comp
    category="Buy-Sell-Plans-Employees"
    [gridId]="gridId"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    [clearSelectedItems]="clearSelectedItems"
    actionButtonText="Add"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="false"
    [isLoading]="isLoading"
    searchable="true"
    showRefreshButton="true"
    (emitRefreshEvent)="getBuySellPlanEmployees()"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    (emitOpenDialogEvent)="openAddEmployeesDialog()"
    (emitGridStateChangeEvent)="gridStateChange($event)"
    (emitDeleteEvent)="openConfirmDeleteDialog($event)"
></app-data-grid-comp>